module.exports = __webpack_public_path__ + "media/src/website/images/locations/tittmoning/02-19c944243b6e20e91030bdf63ee15889.jpg";